<template>
    <v-flex>
        <upcoming-event :isConsiderTheseEventGadget = false></upcoming-event>
        <upcoming-event :isConsiderTheseEventGadget = true></upcoming-event>
    </v-flex>
</template>

<script>
    import UpcomingEvent from '@/components/ChapterPage/UpcomingEvents/UpcomingEvent';

    export default {
        name: "HomeRightSidebar",
        components: {
            UpcomingEvent,
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";

    .time_block {
        margin: 20px 10px 10px 10px;
        padding: 10px 5px;
        border-radius: 4px;
        box-shadow: 0 1px 3px 0 rgba($black, 0.18);
        border: 1px solid rgba($ypo-gray, 0.4);

        .date {
            color: $ypo-dark-background-gray;
            line-height: 12px;
            padding-left: 5px;

            span {
                font-size: 12px;
                display: block;
                font-weight: 600;
                line-height: normal;
            }

            strong {
                color: $ypo_blue;
                font-family: "Noto Sans";
                font-size: 28px;
                display: block;
                line-height: normal;
                padding: 4px 0;
                font-weight: 400;
            }

            small {
                color: $ypo-dark-background-gray;
                font-size: 10px;
                font-weight: bold;
            }
        }

        .desc {
            color: $ypo_blue;
            font-family: "Noto Sans";
            font-size: 12px;
            font-weight: bold;
            letter-spacing: -0.15px;
            line-height: 17px;
            margin-bottom: 30px;
        }

        .v-avatar {
            border: 1px solid $ypo-medium-gray;
        }

        .member__deatils {
            span {
                color: $ypo-dark-background-gray;
                font-size: 12px;
                letter-spacing: -0.15px;
                line-height: 15px;
                padding-left: 5px;
            }

            .v-btn {
                width: auto;
                height: auto;
                color: $ypo-dark-background-gray;
                font-size: 12px;
                letter-spacing: 0.4px;
                line-height: 16px;
                text-align: right;

                &:hover {
                    &:before {
                        background-color: transparent;
                    }

                    &:active {
                        background-color: transparent;
                    }
                }

                &:focus {
                    background-color: transparent;
                }
            }
        }

        .action-btns {
            border-top: 1px solid $ypo-medium-gray;
            margin-top: 10px;
            padding-top: 5px;
            text-align: center;

            .v-btn {
                padding: 0;
                text-transform: capitalize;
                min-width: auto;
                background: transparent !important;
                box-shadow: none !important;
                height: auto;
                color: $ypo-dark-background-gray;
                font-size: 12px;
                margin: 0;

                &.active {
                    color: $ypo-green;

                    i {
                        color: $ypo-green;
                        margin-top: 0;
                        font-size: 14px;
                        margin-right: 3px;
                    }
                }

                &:hover {
                    &:before {
                        background-color: transparent;
                    }

                    &:active {
                        background-color: transparent;
                    }
                }

                &:focus {
                    background-color: transparent;
                }
            }

            i {
                font-size: 20px;
                color: $ypo-cta;
                margin-top: 5px;
                cursor: pointer;
            }
        }
    }
</style>
